export const GLOBAL_EXPORTER_SETTINGS = {
	MAX_RESULTS: 9999999,
}
